<template>
  <div class="w-100 position-relative" :class="{ show: openSuggestion }">
    <input
      ref="autocompleteRef"
      class="form-control"
      type="text"
      :value="selection"
      @input="setValue"
      @keydown.enter="enter"
      @keydown.down="down"
      @keydown.up="up"
      @click="handleOpenSuggestion"
    />
    <ul class="dropdown-menu w-100" :class="{ show: openSuggestion }">
      <li
        v-for="(suggestion, index) in matches"
        class="d-flex justify-content-between"
        :class="{ active: isActive(index) }"
        :key="suggestion.id"
        @click="suggestionClick(suggestion)"
      >
        <span>{{ suggestion.name }}</span>
        <i
          v-if="canRemove"
          @click="onDeleteItem(suggestion)"
          class="fas fa-times"
        ></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AutocompleteAndCreate',
  props: {
    suggestions: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    open: false,
    current: 0,
    selection: '',
  }),
  computed: {
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    matches() {
      return this.suggestions.filter((e) =>
        e.name.toLowerCase().includes(this.selection.toLowerCase())
      )
    },
    openSuggestion() {
      return this.matches.length != 0 && this.open === true
    },
  },
  mounted() {
    this.configAutoComplete()
  },
  methods: {
    configAutoComplete() {
      const input = this.$refs.autocompleteRef
      input.onfocusout = () => {
        setTimeout(() => {
          this.open = false
        }, 200)
      }
    },
    enter() {
      this.selection = this.matches[this.current]
      this.open = false
    },
    up() {
      if (this.current > 0) this.current--
    },
    down() {
      if (this.current < this.suggestions.length - 1) this.current++
    },
    isActive(index) {
      return index === this.current
    },
    setValue({ target }) {
      this.selection = target.value
      this.model = {
        name: target.value,
      }
    },
    handleOpenSuggestion() {
      if (this.open == false) {
        this.open = true
        this.current = 0
      }
    },
    suggestionClick(suggestion) {
      this.selection = suggestion.name
      this.model = suggestion
      this.open = false
    },
    onDeleteItem(suggestion) {
      setTimeout(() => {
        this.$refs.autocompleteRef.value = null
        this.selection = ''
        this.open = true
      }, 100)
      this.$emit('on-delete', suggestion)
    },
    onClearHandler() {
      this.$refs.autocompleteRef.value = null
      this.selection = ''
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  background-color: white;
  max-height: 10rem;
  overflow-y: auto;

  & li {
    background-color: white;
    color: #182f22;
    margin-bottom: 1px;
    font-size: 16px;
    cursor: pointer;
    padding: 10px 20px;
    border-bottom: 1px solid #c5cdcf;
    font-weight: bold;
  }

  & li:hover .active {
    background-color: #c5cdcf;
  }
}

i {
  color: #e2e2e2;
  font-size: 20px;
}
</style>
